import { Menu } from '../../components/Menu';
import { PDVItem } from '../../components/PDVItem';

import { MiniHeader } from '../../components/MiniHeader';
import { useAppConfig } from '../../hooks/useAppConfig';
import { useEffect, useState } from 'react';
import { ConfigType } from '../../contexts/AppConfigContext';

import { Loading } from '../../components/Loading';
import api from '../../services/api';
import { usePluginspace } from '../../hooks/usePluginspace';
import { ProductType } from '../../contexts/ProductsContext';

export function Favorites() {
    const { getAppConfig } = useAppConfig();
    const { getToken, registerAccess } = usePluginspace();
    const [config, setConfig] = useState<ConfigType | void>();
    const [products, setProducts] = useState<Array<ProductType>>([]);
    const [loading, setLoading] = useState(false);
    const [loadingHeader, setLoadingHeader] = useState(true);

    useEffect(() => {
        registerAccess('favorites')
        getProducts();
        getConfig();
    }, [])

    async function getConfig(){
        setLoadingHeader(true);
        setConfig(await getAppConfig());
        setLoadingHeader(false);
        setLoading(false);
    }

    async function getProducts() {
        setLoading(true);
        await api.get(`/api/favorite`,
        {
            headers: {
                'Authorization': `Bearer ${await getToken()}`
            }
        }).then(async (response) => {
            const productsFavorites = response.data.data.map((favorite: any) => {
                let img = '';
                if(!favorite.variation[0].img.includes('http')){
                    img = `https://s3.amazonaws.com/img.ninegrid.com/${favorite.variation[0].img}`;
                } else {
                    img = favorite.variation[0].img;
                }
                favorite.product[0].images = favorite.product[0].images.map((image:any) => {
                    if(!image.imgsuffix.includes('http')){
                        image.imgsuffix = `${image.path}/${image.imgsuffix}`;
                    }
                    return image
                })
                const obj: ProductType = {
                    id: favorite.product[0].id,
                    classificationId: favorite.product[0].classificationId,
                    code: favorite.product[0].code,
                    description: favorite.product[0].description,
                    name: favorite.product[0].name,
                    status: favorite.product[0].status,
                    images: favorite.product[0].images,
                    img: img,
                    technicalSpecification: favorite.product[0].technicalSpecification,
                    variations: favorite.variation,
                    order: favorite.product[0].order,
                }
                return obj;
                
            })
            setProducts(productsFavorites);
            setLoading(false);
        })
        .catch((err) => {
            console.log(err);
            setLoading(false);
        })
    }

    return(
        <div className="pdv">
            <div className="content-pdv">
                {!loadingHeader && (
                    <MiniHeader 
                        name='favorites' title='Favoritos' 
                        fontColor={config?.webappcolor.fontheader ? config.webappcolor.fontheader : '#636363'}
                        backgroundColor={config?.webappcolor.backgroundheader ? config.webappcolor.backgroundheader : '#F5F5F5'}
                    />
                )}
                { loading ?
                    <div style={{width: '100%', height: 'calc(100vh)'}}>
                        <Loading type='spinningBubbles' color='#FFF' width={64} height={64} />
                    </div>
                :
                    <div className="items-pdv-list">
                        {
                            products.map((product) => {
                                const productImg = product.images.find((image) => image.typeimg === 'image')?.imgsuffix
                                return (
                                    <PDVItem 
                                        id={product.id}
                                        name={product.name}
                                        reference_id={product.variations[0].referenceCode}
                                        price={product.variations[0].price}
                                        promotionalPrice={product.variations[0].promotionalPrice}
                                        image={productImg ? productImg : product.variations[0].img}
                                        inBlocks={false}
                                        key={product.id}
                                        description={product.description}
                                        food={(config?.template === 'food' || config?.template === 'retail')}
                                        fontColor={"#636363"}
                                        discountCoupon={{
                                            color: config?.webappcolor.flagDiscountColor ? config.webappcolor.flagDiscountColor : '#000',
                                            type: config?.content.flagDiscount ? config?.content.flagDiscount : 'trigonal'
                                        }} stock={false} mark={''}                                    />
                                )
                            })
                        }
                    </div>
                }
                {!loadingHeader && (
                    <Menu 
                        fontColor={config?.webappcolor.iconsfooter ? config?.webappcolor.iconsfooter : '#636363'}
                        activeFontColor={config?.webappcolor.highlightfooter ? config?.webappcolor.highlightfooter : '#000'}
                        backgroundMenu={config?.webappcolor.backgroundfooter ? config?.webappcolor.backgroundfooter : '#F5F5F5'}
                        colorIcons={config?.webappcolor.iconsfooter ? config?.webappcolor.iconsfooter : '#636363'}
                        highlightColorIcons={config?.webappcolor.highlightfooter ? config?.webappcolor.highlightfooter : '#636363'}
                        backgroundCart={config?.webappcolor.backgroundcart ? config.webappcolor.backgroundcart : '#FFBA49'}
                        fontCart={config?.webappcolor.fontcart ? config.webappcolor.fontcart : '#000'}
                        noSales={
                            (config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
                                ? config.content.pdv.noSales
                                : false
                        }
                    />
                )}
            </div>
        </div>
    )
}